import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './NavBar';
import Sidebar from './Sidebar';
import { initFlowbite } from 'flowbite';

const MainApp = () => {
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [breadcrumbLink, setBreadcrumbLink] = useState([]);

  useEffect(() => {
    initFlowbite()
  }, [])

  return (
    <>
      <Navbar breadcrumb={breadcrumb} breadcrumbLink={breadcrumbLink} />
      <Sidebar />
      <div className="flex pt-16 overflow-hidden dark:bg-gray-900">
        <div className="fixed inset-0 z-10 hidden bg-gray-900/50 dark:bg-gray-900/90" id="sidebarBackdrop"></div>
        <div id="main-content" className="relative w-full h-full overflow-y-auto bg-white lg:ml-64 dark:bg-gray-900">
          <main className='min-h-[90vh]'>
            <Outlet context={[setBreadcrumb, setBreadcrumbLink]}></Outlet>
      {/* Footer */}
      <footer className="px-4 md:px-8 py-8 border-t border-gray-200 pt-6 text-xs text-gray-500 flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
        <div>
          <span>© 2025 Webhizzy Solutions</span>
          <span className="mx-1">•</span>
          <a href="https://webhizzy.in/privacy-policy.html" target='_blank' className="hover:underline">Privacy Policy</a>
          <span className="mx-1">•</span>
          <a href="https://webhizzy.in/terms&conditions.html" target='_blank' className="hover:underline">Terms & Conditions</a>
        </div>
        <div>
          <label htmlFor="lang" className="mr-2">Language:</label>
          <select id="lang" className="text-sm p-0 ps-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400">
            <option>English</option>
          </select>
        </div>
      </footer>
          </main>
        </div>
      </div>
      <script src="https://unpkg.com/flowbite@latest/dist/flowbite.js"></script>
    </>
  );
};

export default MainApp;
